export enum BannerType {
  GoodBetterBest = "GoodBetterBest",
  SideBySide = "SideBySide",
}
